import Vue from "vue";
import Vuex from "vuex";
import CHANGES from "@/services/admin/changelogs";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    changelogs: [],
    loadedChangelogs: [],
    latestChangelog: null,

  },
  getters: {
    changelogs: (state) => state.changelogs,
    latestChangelog: (state) => state.latestChangelog,
  },
  mutations: {
    setChangelogs(state, changelogs) {
      const loadedChangelogs = new Set(state.loadedChangelogs);
      changelogs.forEach((changelog) => {
        if (!loadedChangelogs.has(changelog.id)) {
          loadedChangelogs.add(changelog.id);
          state.changelogs.push(changelog);
        }
      });
      state.loadedChangelogs = Array.from(loadedChangelogs);
    },
    setLatestChangelog(state, changelog) {
      state.latestChangelog = changelog;
    },
    clearState(state) {
      state.changelogs = [];
      state.loadedChangelogs = [];
      state.latestChangelog = null;
    },
  },
  actions: {
    clearState({ commit }) {
      commit("clearState");
    },
    async getLatestChangelog({ commit, state }) {
      try {
        if (state.changelogs.length > 0) return state.changelogs[0];

        const { changelog } = await CHANGES.getLatest();
        commit("setLatestChangelog", changelog);

        return changelog;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    async loadMoreChangelogs({ commit, state }, take = 5) {
      try {
        debugger;
        const { changelogs } = await CHANGES.getChangelogs(state.changelogs.length, take);
        commit("setChangelogs", changelogs);
        return changelogs;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
